import { render, staticRenderFns } from "./onlineBusiness.vue?vue&type=template&id=7958a19c&scoped=true&"
import script from "./onlineBusiness.vue?vue&type=script&lang=js&"
export * from "./onlineBusiness.vue?vue&type=script&lang=js&"
import style0 from "./onlineBusiness.vue?vue&type=style&index=0&id=7958a19c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7958a19c",
  null
  
)

export default component.exports